import {useContext} from "react";
import CarContext from "../../../context/CarContext";
import TestData from "./classes/TestData";

function tryParseBegTest(data) {
    try {
        return new TestData(data);
    } catch (e) {
        return null
    }
}

export default function GetBegTestData() {
    const {car: {beg_tests: [begTest]}} = useContext(CarContext);
    return tryParseBegTest(begTest);
}